// extracted by mini-css-extract-plugin
export default {"bar":"wQlROjWk","dot":"ImclskEN"};